import React, {useEffect } from 'react';
import styles from './ValidateSuccess.module.scss';
import { validationSuccess } from '../../store/actions/authActions';
import { Link } from 'react-router-dom';
import Facebook from '../../assets/svg/facebookSvg.svg';
import Twitter from '../../assets/svg/twitterSvg.svg';
import LinkedIN from '../../assets/svg/linkedinSvg.svg';
import Instragram from '../../assets/svg/instagramSvg.svg';
import { connect } from 'react-redux';
import { fireAnalytics } from '../../utils/firebase';
import { motion } from 'framer-motion';

const variants = {
    hidden: { opacity: 0, x: -100 },
    visible: { opacity: 1, x: 0 }
}


const ValidateSuccess = ({ validationSuccess, ...props }) => {

    useEffect(() => {
        fireAnalytics("validacion_exitosa", { category: "usuario" });
    }
    ,[])

    return (
        <motion.section
            initial="hidden"
            animate="visible"
            variants={variants}
            transition={{ duration: 0.5 }}
        className={styles.ValidateSuccess}>
            <div className={styles.content}>
                <div className={styles.textContainer}>
                    <h2 className={styles.title}>
                        ¡Tu cuenta ha sido <span>validada con éxito!</span>
                    </h2>
                    <h4 className={styles.subtitle}>
                        Gracias por elegirnos. Tu cuenta ha sido validada con éxito. Ahora podés disfrutar de todos los beneficios de Edify.
                    </h4>
                </div>
                <div className={styles.btnFinish} onClick={() => validationSuccess(false)}>
                    <Link to={'/'}>Ir al login</Link>
                </div>
                <div className={styles.socialsContainer}>
                    <div className={styles.followUs}>
                        Seguinos en:
                    </div>
                    <div className={styles.icons}>
                        <a className={styles.icons_img} target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/p/Edify-100063884114544/"><img src={Facebook} alt="" /></a>
                        <a className={styles.icons_img} target="_blank" rel="noopener noreferrer" href="https://twitter.com"><img src={Twitter} alt="" /></a>
                        <a className={styles.icons_img} target="_blank" rel="noopener noreferrer" href="https://ar.linkedin.com/company/edifyargentina"><img src={LinkedIN} alt="" /></a>
                        <a className={styles.icons_img} target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/edify.la/?hl=es-la"><img src={Instragram} alt="" /></a>
                    </div>
                </div>
            </div>
        </motion.section>
    )
}


export default connect(null, { validationSuccess })(ValidateSuccess);
